export const getWx = () => (window as any).wx;

export const previewWxImage = (url?: string) => {
  if (!url) return;
  getWx()?.previewImage({
    current: url,
    urls: [url],
  });
};
